import MicroModal from 'micromodal';
import {getURLParameter} from '../utils';
import {decimalToFraction, fractionToDecimal, roundDecimal} from "../utils/math";
import openBVModal from "../utils/bv";
import {SMS} from "../controllers/SMS";
import React from 'react';

const {Fraction} = require('fractional');

export default class RecipeSingle {

    static instance = null;

    static getInstance() {
        if (RecipeSingle.instance === null) {
            RecipeSingle.instance = new RecipeSingle();
        }
        return RecipeSingle.instance;
    }

    init() {
        if(Electro.DEBUG) {
            console.log('RecipeSingle.init');
        }
        // Submit new user form
        const newUserForm = document.querySelector('.new-user-form');
        if (newUserForm) {
            $(newUserForm).parsley();
            newUserForm.addEventListener('submit', async (e) => {
                e.preventDefault();
                // Disable the submit button
                newUserForm.querySelector('button[type="submit"]').disabled = true;
                await this.submitNewUserForm(e);
                // Enable back the submit button
            });
        }

        document.querySelectorAll('.sms-opt-in-form').forEach(form => {
            $(form).parsley();
            form.addEventListener('submit', async (e) => {
                e.preventDefault();
                // Disable the submit button
                form.querySelector('button[type="submit"]').disabled = true;
                await this.submitOptInForm(e);
                // Enable back the submit button
                form.querySelector('button[type="submit"]').disabled = false;
            });
        });
    }
    async submitNewUserForm(e) {
        const form = e.target;

        if (!$(form).parsley().isValid) {
            console.log('Form is not valid.');
            return;
        }

        const formData = new FormData(e.target);
        const formValues = {};

        // Iterate through the FormData entries
        Array.from(formData.entries()).forEach(([name, value]) => {
            formValues[name] = value;
        });

        // Is this a recipe form?
        if (form.querySelector('input[name="recipe_id"]')) {
            formValues.recipe = form.querySelector('input[name="recipe_id"]').value;
        }

        fetch('/wp-json/clorox-preference-center/v1/newsletter/', {
            method: 'POST',
            headers: {
                credentials: 'same-origin',
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formValues),
        })
            .then((result) => result.json())
            .then((json) => {
                if (Electro.DEBUG) {
                    console.info(json);
                }
                if(json.status === 0) {
                    // Success
                    if( Electro.DEBUG){
                        console.log('Success:', json);
                    }
                    // Display the confirmation
                    this.displayConfirmation(form);

                    // Save the encrypted consumer id to the session storage
                    sessionStorage.setItem('consumerId', json.data?.encrypted_consumer_id);
                } else {
                    if( Electro.DEBUG ) {
                        console.error('Error:', json);
                    }
                    form.querySelector('.error-message').textContent = json.message;
                    form.querySelector('.error-message').classList.remove('hidden');
                }
            });

    }

    async submitOptInForm(e) {
        const form = e.target;

        if (!$(form).parsley().isValid) {
            console.log('Form is not valid.');
            return;
        }

        // Check the user data, to update the globals first.
        await RecipeSingle.checkUserData();

        // Send a fetch request
        const formData = new FormData(e.target);
        const formValues = {};

        // Iterate through the FormData entries
        for (const [name, value] of formData.entries()) {
            formValues[name] = value;
        }

        // Is this a recipe form?
        if (form.querySelector('input[name="recipe_id"]')) {
            formValues.recipe = form.querySelector('input[name="recipe_id"]').value;
        }

        fetch('/wp-json/electro/v1/sms/optInUser/', {
            method: 'POST',
            headers: {
                credentials: 'same-origin',
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-WP-Nonce': Electro.wp_rest_nonce,
            },
            body: JSON.stringify(formValues),
        })
        .then(response => response.json())
        .then(data => {
            if ( data.status === 0 ) {
                if( Electro.DEBUG ) {
                    console.log('Success:', data);
                }
                this.displayConfirmation(form);
            } else {
                if( Electro.DEBUG ) {
                    console.error('Error:', data);
                }
                form.querySelector('.error-message').textContent = data.message;
                form.querySelector('.error-message').classList.remove('hidden');
            }
        });
    }

    /**
     * This checks the user's SMS opt-in status, against the SMS API.
     *
     * This only runs if the optin status is false.
     */
    static checkUserData() {
        // Run conditionals
        if (!SMS.isUserOptedIn()) {
            // Wait for the response, then update the globals for the user
            return new Promise((resolve, reject) => {
                const encryptedConsumerId = sessionStorage.getItem('consumerId') ?? '';
                const request = fetch(`/wp-json/electro/v1/sms/getUserData/`, {
                    method: 'GET',
                    headers: {
                        credentials: 'same-origin',
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': Electro.wp_rest_nonce,
                        'X-Electro-Encrypted-Consumer-Id': encryptedConsumerId,
                    }
                });
                request.then(response => response.json())
                    .then(data => {
                        if (data.status !== 0) {
                            resolve(data.message);
                        }
                        if (Electro.DEBUG) {
                            console.log('Success:', data);
                        }
                        // Update the globals
                        Electro.SMSOptedIn = data.optedIn === 1;
                        Electro.HasPhoneMobile = data.phoneMobile !== '';
                        resolve(data);
                    }).catch(error => {
                    if (Electro.DEBUG) {
                        console.error('Error:', error);
                    }
                    reject(error);
                });

            });
        }

        // Resolve with no data
        return Promise.resolve();
    }

    displayConfirmation(form) {
        if (Electro.DEBUG) {
            console.info('SmsOptIn.displayConfirmation');
        }
        const container = form.closest('.content-container');
        container.querySelector('.form-container').classList.add('hidden');
        container.querySelector('.form-container').remove();
        container.querySelector('.confirmation').classList.remove('hidden');
    }
}

/**
 * Notification for save recipe
 *
 * @param title
 * @param recipe
 */
function createConfirmationNotification(title, recipe) {
    const notificationWrapper = document.createElement('div');
    notificationWrapper.classList.add('notification-wrapper');
    notificationWrapper.innerHTML = `
        <div class="notification-container">
        <div class="notification-title-wrapper">
            <p class="notification-title">${title}</p>
            <button type="button" class="notification-close-button">
            <img class="e-icon" src="/wp-content/themes/electro/img/svg/x-dark.svg" alt="Close" width="10" height="10" />
            </button>
        </div>
        <div class="notification-content-wrapper">
            <img class="notification-thumbnail" src="${recipe.thumbnail}?quality=50" alt=""></img>
            <p class="notification-description">${recipe.title}<p>
        </div>
        </div>
    `;
    document.body.appendChild(notificationWrapper);

    notificationWrapper.querySelector('.notification-close-button').addEventListener('click', () => {
        notificationWrapper.querySelector('.notification-container').classList.remove('is-active');

        setTimeout(() => {
            notificationWrapper.remove();
        }, 2000);
    });

    setTimeout(() => {
        notificationWrapper.querySelector('.notification-container').classList.add('is-active');
    }, 100);
}

/**
 * Check if element is in viewport
 *
 * @param element
 */
function elementInViewport(element) {
    let el = element;
    let top = el.offsetTop;
    let left = el.offsetLeft;
    const width = el.offsetWidth;
    const height = el.offsetHeight;

    while(el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    return (
      top < (window.pageYOffset + window.innerHeight) &&
      left < (window.pageXOffset + window.innerWidth) &&
      (top + height) > window.pageYOffset &&
      (left + width) > window.pageXOffset
    );
}

/**
 * Initialize Sticky Nav
 */
function stickyNav() {
    const steps = document.querySelectorAll('[data-step]');
    let currentStep = 0;

    // Add some extra padding to the Common Branding Footer
    const commonBrandingFooter = document.querySelector('.common-branding-banner--footer');
    commonBrandingFooter.classList.add('extra-padding');

    $('.js-previous-step').on('click', (e) => {
        e.preventDefault();

        if (currentStep > 0) {
            currentStep -= 1;
            steps[currentStep].scrollIntoView({behavior: 'smooth'});
        }
    });

    $('.js-next-step').on('click', (e) => {
        e.preventDefault();

        if (currentStep < (steps.length -1 )) {
            currentStep += 1;
            steps[currentStep].scrollIntoView({behavior: 'smooth'});
        }
    });

    $('.js-goto-step').on('click', (e) => {
        e.preventDefault();

        const goto = e.currentTarget.getAttribute('data-goto');

        steps.forEach((step, index) => {
            if (step.id === goto) {
                currentStep = index;
                steps[currentStep].scrollIntoView({behavior: 'smooth'});
            }
        });
    });

    window.addEventListener('scroll', () => {
        const element = document.querySelector('.b-recipe-hero-with-video');
        const nav = document.querySelector('.b-recipe-hero-with-video__recipe-sticky-nav');

        if (!elementInViewport(element) ) {
            nav.classList.add('active');
        } else {
            nav.classList.remove('active');
        };
    });
}

function setIngredientValues() {
    const values = document.querySelectorAll('.amount__quanity.wprm-adjustable');
    values.forEach((value, index) => {
        // Save the current value to a new data-value attribute, to be used later.
        value.setAttribute('data-value', value.innerHTML);
        /**
         * Handle the values that has an average with a "-" in the middle.
         * @type {boolean}
         */
        let average = false;
        if( value.innerHTML.includes('-') ) {
            let counts = value.innerHTML.split('-');
            counts = counts.map((x) => parseInt(x, 10));
            const getAverage = array => array.reduce((a,b) => a + b, 0) / array.length;
            average = getAverage(counts);
        }

        const num = Math.round((average || value.innerHTML) / 0.25) * 0.25;
        const rounded = Math.floor(num);
        const rest = num - Math.floor(num);
        const f = new Fraction(rest);

        if (!Number.isNaN(f.numerator)) {
            if (rounded > 0) {
                if (f.numerator > 0) {
                    value.innerHTML = `${rounded} &frac${f.numerator}${f.denominator};`;
                } else {
                    value.innerHTML = `${rounded}`;
                }
            } else {
                value.innerHTML = `&frac${f.numerator}${f.denominator};`;
            }
        }
    });
}

function initProTips() {
    const overlay = document.querySelector('.js-protip-overlay');

    $('.js-protip').hover( (e) => {
        $(e.currentTarget).addClass('hover');
    }, (e) => {
        $(e.currentTarget).removeClass('hover');
    });

    $('.js-protip-toggle').on('click', (e) => {
        e.preventDefault();

        $(e.currentTarget).parent().toggleClass('active');
        overlay.classList.toggle('is-active');

        $('.js-protip-close').blur();
    });
    $('.js-protip-close').on('click', (e) => {
        e.preventDefault();
        overlay.classList.remove('is-active');

        const activeProTip = document.querySelector('.js-protip.active');
        activeProTip.classList.remove('active');
        activeProTip.classList.remove('hover');

        $('.js-protip-close').blur();
    });

    overlay.addEventListener('click', () => {
        overlay.classList.remove('is-active');

        const activeProTip = document.querySelector('.js-protip.active');
        activeProTip.classList.remove('active');
        activeProTip.classList.remove('hover');
    });
}

function modalListeners() {
    $('.js-save-change').on('click', (e) => {
        e.preventDefault();

        fetch('/wp-json/kingsford/v1/newsletter/', {
            method: 'POST',
            headers: {
                'X-WP-Nonce': Electro.wp_rest_nonce,
                credentials: 'same-origin',
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                brandOptIn: $('.js-newsletter-form input[name="pc_brandOptIn"]').is(':checked') ? '1' : '0',
            }),
        })
        .then((result) => result.json())
        .then((json) => {
            if (Electro.DEBUG) {
                console.info(json);
            }
            if(json.status === 0) {
                MicroModal.close('modal-trending--newsletter');
                // remove ?trending=true from url
                const url = window.location.href;
                const newUrl = url.split('?')[0];
                window.history.pushState({}, '', newUrl);

                // reload page
                window.location.reload();
            }
        });

        return false; // prevent default
    });
}

// init swiper and event handlers
function initializePage() {
    openBVModal();
    stickyNav();
    setIngredientValues();
    initProTips();

    if (getURLParameter('trending') === 'true') {
        const trendingBanner = document.querySelector('.rdp-trending-banner');
        trendingBanner.style.display = 'block';
        trendingBanner.style.visibility = 'visible';
    }

    $('.js-newsletter-signup-toggle').on('click', (e) => {
        e.preventDefault();

        if (!CLWP_PC_GLOBAL.isLoggedIn) {
            MicroModal.show('modal-trending--signup', {
                disableScroll: true,
                disableFocus: true,
                closeTrigger: 'data-custom-close',
            });
        } else {
            MicroModal.show('modal-trending--newsletter', {
                onShow: modalListeners,
                disableScroll: true,
                disableFocus: true,
                closeTrigger: 'data-custom-close',
            });
        }
    });


    /**
     * copy to clipboard
     *
     * @param text to copy
     */
    function copyToClipboard(text) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        textArea.setSelectionRange(0, 99999);
        navigator.clipboard.writeText(textArea.value);
        textArea.remove();
    }

    // handle copy to clipboard
    $('.js-copy-to-clipboard').on('click', (e) => {
        e.preventDefault();
        const text = document.URL;
        copyToClipboard(text);

        $('.js-share-recipe-menu').removeClass('is-active');
        $('.js-copied-wrapper').toggleClass('is-active');
        $('.js-share-recipe-button').focus();
        setTimeout(() => {
            $('.js-copied-wrapper').toggleClass('is-active');
        }, 2000);
    });

    // handle share recipe
    $('.js-share-recipe-button').on('click', (e) => {
        e.preventDefault();

        const menuEl = e.currentTarget.parentNode.querySelector('.js-share-recipe-menu');
        menuEl.classList.toggle('is-active');

        setTimeout(() => {
            menuEl.classList.remove('is-active');
        }, 2000);
    });

    // handle print
    $('.js-print-recipe').on('click', (e) => {
        e.preventDefault();
        if (Electro.DEBUG) {
            console.info('Printing recipe...');
        }

        window.print();
    });

    $('.js-sms-recipe').on('click', (e) => {
        e.preventDefault();
        if (Electro.DEBUG) {
            console.info('SMS recipe');
        }
        RecipeSingle.checkUserData().then(() => {
            SMS.triggerModal();
        });
    });

    // handle recipe save
    $('.js-save-recipe').on('click', (e) => {
        e.preventDefault();
        if (Electro.DEBUG) {
            console.info('SAVE RECIPE!');
        }

        if (!CLWP_PC_GLOBAL.isLoggedIn) {
            console.warn('Need to be logged in');
            return false;
        }

        const currentTrigger = e.currentTarget;
        if (currentTrigger.dataset.saved === '1') {
            console.warn('Already saved');
            return false;
        }

        // rest call to save recipe
        fetch('/wp-json/wp-recipe-maker/v1/recipe-collections/inbox/', {
            method: 'POST',
            headers: {
                'X-WP-Nonce': wprm_public.api_nonce,
                credentials: 'same-origin',
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                recipeId: currentTrigger.dataset.recipeId,
            }),
        })
            .then((result) => result.json())
            .then((json) => {
                if (json && json === true) {
                    currentTrigger.dataset.saved = '1';
                    createConfirmationNotification('This item has been saved to your profile under recipes', {
                        thumbnail: currentTrigger.dataset.thumbnail,
                        title: currentTrigger.dataset.title,
                    });
                }
            });

        return false; // prevent default
    });

    $('.js-launch-video-modal').on('click', (e) => {
        e.preventDefault();
        MicroModal.show('modal-video-embed', {
            disableScroll: true,
            closeTrigger: 'data-custom-close',
        });
    });

    $('.js-video-play').on('click', (e) => {
        e.preventDefault();
        const $el = $(e.currentTarget);
        const $container = $el.closest('.single-part__content');
        const $video = $container.find('.video-embed__video');
        const $poster = $container.find('.video-poster');
        const $content = $container.find('.video-embed__content');

        $video.removeClass('hidden');
        $poster.fadeOut('fast');
        $content.fadeOut('fast');
    });

    // parameter to initiate save - used when user needs to login
    if (getURLParameter('do_action') === 'save-recipe') {
        $('.js-save-recipe').click();
    }

    // .chrome styling
    const servingsSlider = document.getElementById('servings-slider');
    $(servingsSlider).css(
        'background',
        `linear-gradient(to right, #194C97 0%, #194C97 ${
            servingsSlider.value * 5
            }%, #EFEFEF ${
            servingsSlider.value * 5
            }%, #EFEFEF 100%)`
    );

    $(servingsSlider).on('input', function () {
        $(this).css(
            'background',
            `linear-gradient(to right, #194C97 0%, #194C97 ${
                this.value * 5
                }%, #EFEFEF ${
                this.value * 5
                }%, #EFEFEF 100%)`
        );
    });

    /**
     * Handle the servings slider on change event by customizing the servings' values.
     */
    $(servingsSlider).on('change click', () => {
        const servings = document.querySelectorAll('.amount__quanity.wprm-adjustable');
        servings.forEach((serving) => {
            // Check the amount__unit part, if it has "of", to leave it as is.
            // This helps with the non-numerical values, like "drizzle"/"pinch" "of".
            const amountUnit = serving.parentNode.querySelector('.amount__unit');
            if(amountUnit && amountUnit.innerHTML !== 'of'){
                const servingValue = fractionToDecimal(serving.innerHTML.toString());
                const roundedDecimal = roundDecimal(servingValue);
                serving.innerHTML = decimalToFraction(roundedDecimal);
            } else{
                // Override what WPRM does by changing non-numerical values to small decimals.
                serving.innerHTML = serving.getAttribute('data-value');
            }
        });

    });
}

window.addEventListener('DOMContentLoaded', ()=>{
    // If not single recipe, then return
    const singleRecipe = document.querySelector('body').classList.contains('single-kfd_recipe');
    if(!singleRecipe) return;

    // If the instance already exists, then return
    if(window.Electro.singleRDP) return;


    // Create the instance and initialize
    window.Electro.singleRDP = RecipeSingle.getInstance();
    window.Electro.singleRDP.init();

    // Add other methods
    initializePage();

    // Add tracking
    function activateTrendingRecipesBanner() {
        const trendingBanner = document.querySelector('.rdp-trending-banner');
        trendingBanner.style.display = 'block';
        trendingBanner.style.visibility = 'visible';
    }
    window.activateTrendingRecipesBanner = activateTrendingRecipesBanner.bind();

})


